<template>
    <div class="soli-user-instruments">
        <v-select
            v-if="!buttons && !autocomplete"
            v-on:input="$emit('input', $event)"
            :items="getInstruments"
            :value="value"
            :loading="!apiInstruments && !instruments"
            :multiple="multiple"
            :label="label"
            :prepend-inner-icon="hideIcon ? null : 'music_note'"
            :clearable="clearable"
            :hideDetails="hideDetails"
            return-object
            outlined
            dense
            item-text="name"
            item-value="id"
            :error-messages="errorMessages"
            @click:clear="$emit('clear')"
        ></v-select>
        <v-autocomplete
            v-if="autocomplete && !buttons"
            :loading="!apiInstruments && !instruments"
            :value="value"
            :items="getInstruments"
            :hideDetails="hideDetails"
            :prepend-inner-icon="hideIcon ? null : 'music_note'"
            :menu-props="{
                closeOnContentClick: true,
            }"
            :multiple="multiple"
            :label="label"
            :clearable="clearable"
            outlined
            return-object
            dense
            item-value="id"
            item-text="name"
            no-data-text="No instruments available"
            class="soli-blue-text"
            @input="$emit('input', $event)"
            @keydown.enter.prevent
            @click:clear="$emit('clear')"
        />
        <v-list v-if="buttons">
            <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="list-item, list-item, list-item"
                v-if="!apiInstruments && !instruments"
            ></v-skeleton-loader>
            <!--<div class="text-center">
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </div>-->
            <v-list-item
                v-for="instrument in getInstruments"
                :key="instrument.id"
            >
                <SoliBtn
                    block
                    @click="$emit('input', instrument)"
                    :text="instrument.name"
                    color="contrast--text"
                    outlined
                    class="py-1"
                ></SoliBtn>
            </v-list-item>
            <div
                v-if="getInstruments ? getInstruments.length == 0 : false"
                class="flex justify-center"
            >
                No available instruments for this selection.
            </div>
        </v-list>
    </div>
</template>

<script>
export default {
    props: {
        instruments: {
            type: Array,
            default: null,
            description:
                "This does not necessarily match the function of the component. The api call is looking specifically for available instruments",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        buttons: {
            type: Boolean,
            default: false,
        },
        hideIcon: { type: Boolean, default: false },
        hideDetails: { type: [Boolean, String], default: false },
        clearable: { type: Boolean, default: false },
        availabilities: { default: null },
        value: {},
        location: { default: null },
        user: { default: null },
        teacher: { default: null },
        inStudio: {
            type: Boolean,
            default: false,
        },
        bookingType: {
            type: String,
            default: null,
        },
        onlyAuth: {
            type: Boolean,
            default: false,
        },
        showAll: {
            type: Boolean,
            default: false,
        },
        autocomplete: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: () => [],
        },
    },
    data: function () {
        return {
            apiInstruments: null,
        };
    },
    computed: {
        label() {
            return this.multiple ? "Instruments" : "Instrument";
        },
        getInstruments() {
            return this.instruments == null
                ? this.apiInstruments
                : this.instruments;
        },
    },
    mounted() {
        if (this.instruments) return;
        if (this.showAll && !this.teacher) {
            return axios.get("/api/instruments").then((resp) => {
                this.apiInstruments = resp.data;
            });
        }
        axios
            .get("/api/instruments/available", {
                params: {
                    location: this.location
                        ? this.location.id
                        : this.$page.props.auth.user.selected_location.id,
                    user_id: this.user ? this.user.id : null,
                    teacher_id: this.teacher?.id,
                    inStudio: Number(this.inStudio),
                    bookingType: this.bookingType,
                    onlyAuth: Number(this.onlyAuth),
                },
            })
            .then((resp) => (this.apiInstruments = resp.data));
    },
};
</script>
